import styles from './MiniSpinner.module.css';

export const MiniSpinner = () => {
  return (
    <div className={styles.ldsfacebook}><div></div><div></div><div></div></div>
  )
}